import React, { Fragment } from "react";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";

function MuiPaper({ title, loading, children, className }) {
  return (
    <Fragment>
      {loading ? (
        <Skeleton variant="rect" animation="wave" height={200} />
      ) : (
        <Paper className={`paper ${className}`}>
          <span>{title}</span>
          {children}
        </Paper>
      )}
    </Fragment>
  );
}

export default MuiPaper;
